import { DesignsystemProvider } from '@hausgold/designsystem';
import { VARIANTS } from './utils/CONSTANTS.js';
import PropTypes from 'prop-types';
import React from 'react';
import Clean from './components/variants/Clean/index.js';
import CTA from './components/variants/CTA/index.js';
import CTA2 from './components/variants/CTA2/index.js';
import Default from './components/variants/Default/index.js';
import Default$1 from './components/variants/Extended/index.js';
import Highlighted from './components/variants/Highlighted/index.js';
import Raffle from './components/variants/Raffle/index.js';
import defaultConfig from './defaultconfig.js';
export { default as FormwizardConfig } from './defaultconfig.js';
import theme from './utils/theme.js';
import { jsx } from '@emotion/react';
var FormwizardChooser = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
    dialogId = _ref.dialogId,
    recruiterId = _ref.recruiterId,
    dialogConfig = _ref.dialogConfig,
    leadId = _ref.leadId,
    theme = _ref.theme,
    config = _ref.config,
    isLocal = _ref.isLocal,
    position = _ref.position,
    doTrack = _ref.doTrack,
    appsignal = _ref.appsignal;
  var ComponentVariant;
  switch (variant) {
    case VARIANTS.HIGHLIGHTED:
      ComponentVariant = Highlighted;
      break;
    case VARIANTS.CLEAN:
      ComponentVariant = Clean;
      break;
    case VARIANTS.CTA:
      ComponentVariant = CTA;
      break;
    case VARIANTS.CTA2:
      ComponentVariant = CTA2;
      break;
    case VARIANTS.EXTENDED:
      ComponentVariant = Default$1;
      break;
    case VARIANTS.RAFFLE:
      ComponentVariant = Raffle;
      break;
    case VARIANTS.DEFAULT:
    default:
      ComponentVariant = Default;
      break;
  }
  return jsx(DesignsystemProvider, {
    resetCSS: false,
    theme: theme,
    fonts: false
  }, jsx(ComponentVariant, {
    appsignal: appsignal,
    config: config,
    key: variant,
    dialogId: dialogId,
    recruiterId: recruiterId,
    dialogConfig: dialogConfig,
    leadId: leadId,
    isLocal: isLocal,
    position: position,
    ref: ref,
    variant: variant,
    doTrack: doTrack
  }));
});
FormwizardChooser.propTypes = {
  dialogId: PropTypes.string,
  recruiterId: PropTypes.string,
  dialogConfig: PropTypes.object,
  leadId: PropTypes.string,
  theme: PropTypes.object,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  config: PropTypes.shape({
    api: PropTypes.shape({
      urls: PropTypes.shape({
        wizard: PropTypes.shape({
          http: PropTypes.string.isRequired
        }).isRequired
      }).isRequired
    }).isRequired,
    analytics: PropTypes.shape({
      segmentKey: PropTypes.string
    })
  }),
  appsignal: PropTypes.object,
  isLocal: PropTypes.bool,
  doTrack: PropTypes.bool,
  position: PropTypes.oneOf(['right', 'top', 'header'])
};
FormwizardChooser.defaultProps = {
  dialogId: 'standard-01',
  recruiterId: null,
  dialogConfig: undefined,
  variant: VARIANTS.DEFAULT,
  leadId: null,
  theme: theme,
  isLocal: false,
  config: defaultConfig,
  position: null,
  doTrack: true,
  appsignal: null
};
export { FormwizardChooser as default };